import { render, staticRenderFns } from "./SplitContainer2.vue?vue&type=template&id=39f8c7f5"
import script from "./SplitContainer2.vue?vue&type=script&lang=js"
export * from "./SplitContainer2.vue?vue&type=script&lang=js"
import style0 from "./SplitContainer2.vue?vue&type=style&index=0&id=39f8c7f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports